import { Box, Stack, Text, Title } from "@mantine/core";
import { AccessChecker } from "components/auth/AccessChecker";
import { InnerMarkdown } from "components/_common/InnerMarkdown";
import { LimitedAccessComponent } from "components/_common/LimitedAccessComponent";
import { useMobile } from "shared/hooks/useMobile";
import { useWindowScrollToPosition } from "shared/hooks/useWindowScrollToPosition";
import { useProject } from "shared/hooks/_projects/useProject";

export const ProjectAboutPage = () => {
  const { setOption } = useMobile();
  const ref = useWindowScrollToPosition(setOption(-150, -200));
  const project = useProject({ withoutEffect: true });

  if (!project.data) return null;

  const html = project.data.aboutProject;
  return (
    <Stack ref={ref}>
      <AccessChecker rejectChildren={<LimitedAccessComponent />}>
        <InnerMarkdown>{html || ""}</InnerMarkdown>
        <Box>
          <Title mb={10} order={2}>
            О проекте
          </Title>
          <Text>{project.data.description}</Text>
        </Box>
      </AccessChecker>
    </Stack>
  );
};
